import {getNext, getStepByKey} from "./StepsReducers";
import {INLINE_LOADED_RESET} from "../inline/InlineActions";

export const STEP_NEXT = 'STEP_NEXT';
export const STEP_ALLOW = 'STEP_ALLOW';
export const STEP_DISALLOW = 'STEP_DISALLOW';

export const next = step => (dispatch) => {
  dispatch({type: STEP_NEXT, step});
};

export const select = step => (dispatch, getState) => {
  if (typeof step === 'string') {
    step = getStepByKey(getState(), step);
  }
  if (step.isAllowed) {
    dispatch({type: STEP_NEXT, step: step.key});
    dispatch({type: INLINE_LOADED_RESET});
  }
};

export const finish = () => (dispatch, getState) => {
  const nextStep = getNext(getState());
  if (nextStep) {
    dispatch({type: STEP_ALLOW, step: nextStep.key});
    dispatch({type: STEP_NEXT, step: nextStep.key});
    dispatch({type: INLINE_LOADED_RESET});
  }
};



// WEBPACK FOOTER //
// ./src/steps/StepsActions.js